import React from 'react';

const PendingPodComponentLoadable = React.lazy(() => import('./PendingPodComponent'));

export {
    PendingPodComponentLoadable
};
